import React, { useState, useEffect } from "react";  // Make sure to include useEffect
import {RadioButtonInput } from '../../components/FormInitiators';
import DynamicTable2 from "../../components/DynamicTable2";


const pensionForm3 = ({ formData, setFormData, onFormDataChange, onBack, onNext }) => {
  

  const handleInputChange = ({ target: { name, value } }) => {
    onFormDataChange({ [name]: value });
  };

  const onTableDataChange = (key) => (rows) => {
    setFormData((prevState) => {
      return { ...prevState, [key]: rows };
    });
  };

  return (
  <div className="google_forms">
      <div className="forms">
    <form className="seventh-pay-arrears-form">
    <h3>Bank Details</h3>

        <label>
              Name of the Bank:
            <input type="text" name="bankName" value={formData.bankName} onChange={handleInputChange} />
        </label>

        <label>
            Branch Name:
            <input type="text" name="branchName" value={formData.branchName} onChange={handleInputChange} />
        </label>

        <label>
            Account Number:
            <input type="text" name="accountNumber" value={formData.accountNumber} onChange={handleInputChange} />
        </label>

        <label>
            IFSC Code:
            <input type="text" name="ifscCode" value={formData.ifscCode} onChange={handleInputChange} />
        </label>


      {/* Navigation Buttons */}
      <div className="seventh-pay-arrears-buttons-container">
        <button type="button" onClick={onBack}>Back</button>
        <button type="button" onClick={onNext}>
         Next
        </button>
      </div>
    </form>
    </div>
    </div>
  );
};

export default pensionForm3;
